module.exports = __webpack_public_path__ + "static/media/ImgPDF.07564009.svg";